module.exports = __webpack_public_path__ + "img/5.24d94a48.png";